import TimeslotPicker from './TimeslotPicker';

export default TimeslotPicker;



// WEBPACK FOOTER //
// ./src/components/BookMarketerPage/components/TimeslotPicker/index.js